const moreThanJustNumbers = (value) => {
  if (!value) {
    return true;
  }
  return !/^\d+$/.test(value);
};
export default moreThanJustNumbers;
